<p>
  <strong>{{ appCopy.panelHeader['excessPayment'+selectedLanguage] }}</strong><br>
  {{currencySymbol === 'CHF' ? currencySymbol+' ' : currencySymbol}}{{ excessBaggagePayment.excessBagCharge.toFixed(2) }}
</p>
<p>
  <strong>{{ appCopy.panelHeader['serviceFee'+selectedLanguage] }}</strong><br>
  {{currencySymbol === 'CHF' ? currencySymbol+' ' : currencySymbol}}{{ excessBaggagePayment.serviceFee.toFixed(2) }}
</p>
<p>
  <strong>{{ appCopy.panelHeader['amountChargedText'+selectedLanguage] }}</strong><br>
  {{currencySymbol === 'CHF' ? currencySymbol+' ' : currencySymbol}}{{ excessBaggagePayment.totalCharge.toFixed(2) }}
</p>
<P>
  <strong>{{ appCopy.panelHeader['paymentStatusText'+selectedLanguage] }}</strong><br>
  {{ excessBaggagePayment.paymentStatus === 1 ? appCopy.panelHeader['pendingText'+selectedLanguage] : excessBaggagePayment.paymentStatus === 2 ? appCopy.panelHeader['settledText'+selectedLanguage] : '' }}
</P>
<p><strong>{{ appCopy.panelHeader['reasonText'+selectedLanguage] }}</strong><br>
  <span *ngIf="excessBaggagePayment.overweightBags > 0">
    {{ excessBaggagePayment.overweightBags }} {{ appCopy.panelHeader['overweightText'+selectedLanguage] }} {{ excessBaggagePayment.overweightBags > 1 ? appCopy.panelHeader['bagsSelectText'+selectedLanguage] : appCopy.panelHeader['bagSelectText'+selectedLanguage] }}
  </span><br>
  <span *ngIf="excessBaggagePayment.overweightBags > 0">
    {{ excessBaggagePayment.excessBags }} {{ appCopy.panelHeader['excessText'+selectedLanguage] }} {{ excessBaggagePayment.excessBags > 1 ? appCopy.panelHeader['bagsSelectText'+selectedLanguage] : appCopy.panelHeader['bagSelectText'+selectedLanguage] }}
  </span><br>
  <span *ngIf="excessBaggagePayment.note !== '' && excessBaggagePayment.note !== null">{{ appCopy.panelHeader['noteText'+selectedLanguage] }}: {{ excessBaggagePayment.note }}</span>
</p>
<p *ngIf="receiptImg"><img class="img-responsive" [src]="receiptImg"></p>
